<script setup>
import { ref, watch, onMounted , defineProps} from 'vue'
import {ExclamationTriangleIcon} from "@heroicons/vue/24/outline";

const props = defineProps({
    company: Object,
})

// QR-Code State
const qrcodeImageUrl = ref('')
const qrCodeLoading = ref(true)
const qrCodeError = ref(false)

// VCard generieren
function generateVCard(company) {
  const {
    humanfirstname,
    humanlastname,
    addressstreet,
    addresshousenumber,
    citycaption,
    postalcodecaption,
    telefonNumber,
    emailAdress
  } = company

  const lines = [
    'BEGIN:VCARD',
    'VERSION:3.0',
    `FN:${humanfirstname} ${humanlastname}`,
    `ADR:;;${addressstreet} ${addresshousenumber};${citycaption};;${postalcodecaption};Germany`,
  ]

  if (telefonNumber) lines.push(`TEL:${telefonNumber}`)
  if (emailAdress) lines.push(`EMAIL:${emailAdress}`)

  lines.push('END:VCARD')

  return lines.join('\n')
}

async function generateQRCodeAsync(company) {
  qrCodeLoading.value = true
  qrCodeError.value = false

  try {

    console.log("company: ", company)

    const data = company.website
        ? (company.website.startsWith('http') ? company.website : `https://${company.website}`) // C
        : generateVCard(company)

    console.log("data: ", data)

    qrcodeImageUrl.value = await fetchQrCodeUrl(data)

  }
  catch (error) {
    qrcodeImageUrl.value = ''
    qrCodeError.value = true
  } finally {
    qrCodeLoading.value = false
  }
}

async function fetchQrCodeUrl(data) {
  const response = await fetch(`https://api.qrserver.com/v1/create-qr-code/?data=${encodeURIComponent(data)}&size=200x200`)
  if (!response.ok) throw new Error('QR-Code API Fehler')
  return response.url
}

watch(() => props.company, async (newVal) => {
      if (!newVal) return
      await generateQRCodeAsync(newVal)
    },
    { immediate: true }
)

</script>

<template>

  <div class="w-32 h-32 relative">
    <!-- Loading Skeleton -->
    <template v-if="qrCodeLoading">
      <div class="w-full h-full bg-white/50 rounded-md animate-pulse"></div>
    </template>

    <!-- Error State -->
    <template v-else-if="qrCodeError">
      <div class="w-full h-full flex items-center justify-center flex-col bg-red-100 text-red-600 rounded-md border border-red-300">
        <exclamation-triangle-icon class="size-6"/>
        <span class="text-sm font-medium text-center">
          QR-Code konnte nicht geladen werden
        </span>
      </div>
    </template>

    <!-- QR Code -->
    <template v-else>
      <div class="w-full h-full p-2 bg-white/50 rounded-md">
        <img alt="QR Code" :src="qrcodeImageUrl" class="w-full h-full object-contain rounded-md" />
      </div>
    </template>
  </div>

</template>

<style scoped>

</style>